import type { CSSProperties, ReactNode } from 'react'
import { use, useMemo } from 'react'
import { defaultTheme, ThemeContext } from '../ThemeContext'
import { cn } from '../../utils'

type Props = {
  children: ReactNode
  isPanelQuestion?: boolean
}

export function SurveyElementLayout({ children, isPanelQuestion = false }: Props) {
  const theme = use(ThemeContext)
  const themeStyle = useMemo<CSSProperties>(() => {
    return {
      '--theme-bg-color': theme.mainColor || defaultTheme.mainColor,
      '--theme-outline-color': theme.mainColor || defaultTheme.mainColor,
      '--theme-text-color': theme.mainTextColor || defaultTheme.mainTextColor,
      '--theme-paragraph-color': '#1B1C1B',
      '--theme-title-color': theme.mainTextColor || '#383636',
    } as CSSProperties
  }, [theme])

  return (
    <div
      className={cn(
        !isPanelQuestion && 'px-6',
        'text-[var(--theme-paragraph-color)]'
      )}
      style={themeStyle}
    >
      {children}
    </div>
  )
}
